import { RootState } from '../store';

//client code
export const clientCodeState = (state: RootState) => state.clientCode.value;
//map
export const currentCoordsState = (state: RootState) => state.currentCoords.value;
export const mapIframeIdState = (state: RootState) => state.mapIframeId.value;
export const currentCoordsToggleValueState = (state: RootState) => state.currentCoordsToggleValue.value;
export const currentRotationAmountState = (state: RootState) => state.currentRotationAmount.value;
export const mapCenterState = (state: RootState) => state.mapCenterCoords.value;
export const mapZoomLevelState = (state: RootState) => state.mapZoomLevel.value;
export const currentMaxZoomState = (state: RootState) => state.currentMaxZoom.value;
export const currentZoomLevelState = (state: RootState) => state.currentZoomLevel.value;
export const isDecreaseZoomControlAmountState = (state: RootState) => state.isDecreaseZoomControlAmount.value;
export const isMapLockedState = (state: RootState) => state.isMapLocked.value;
export const mapLayersState = (state: RootState) => state.mapLayers.value;
export const mapTileUrlState = (state: RootState) => state.mapTileUrl.value;
export const isUsingMeasuringToolState = (state: RootState) => state.isUsingMeasuringTool.value;
export const isMeasuringToolDeleteClickedState = (state: RootState) => state.isMeasuringToolDeleteClicked.value;
export const isHideMapTilesState = (state: RootState) => state.isHideMapTiles.value;
export const isCanAccessMapTileLayerState = (state: RootState) => state.isCanAccessMapTileLayer.value;
export const isSendAnimationEndState = (state: RootState) => state.isSendAnimationEnd.value;
export const isModalOpenState = (state: RootState) => state.isModalOpen.value;
export const modalBodyState = (state: RootState) => state.modalBody.value;
export const mapDetailsBodyState = (state: RootState) => state.mapDetailsBody.value;
export const isSlopeServiceActiveState = (state: RootState) => state.isSlopeServiceActive.value;
export const mapOptionsState = (state: RootState) => state.mapOptions.value;
export const isEditingZoomState = (state: RootState) => state.isEditingZoom.value;
export const isMapZoomingState = (state: RootState) => state.isMapZooming.value;
export const isRegionDataLoadingState = (state: RootState) => state.isRegionDataLoading.value;
export const isShowRegionLayersState = (state: RootState) => state.isShowRegionLayers.value;
export const isShowDetailsButtonState = (state: RootState) => state.isShowDetailsButton.value;
export const isOnMapClickState = (state: RootState) => state.isOnMapClick.value;

export const actionsButtonsState = (state: RootState) => state.actionsButtons.value;
//authorization
export const isAuthorizedToEditState = (state: RootState) => state.isAuthorizedToEdit.value;
export const isEditableState = (state: RootState) => state.isEditable.value;
export const isEditingMainPolygonState = (state: RootState) => state.isEditingMainPolygon.value;
export const isDrawPolygonActiveState = (state: RootState) => state.isDrawPolygonActive.value;
export const isDrawingPolygonState = (state: RootState) => state.isDrawingPolygon.value;
//delete actions
export const deletedLayerIDsState = (state: RootState) => state.deletedLayerIDs.value;
//drawn polygon
export const isEditDrawnPolygonsState = (state: RootState) => state.isEditDrawnPolygons.value;
export const editedDrawnPolygonInfoState = (state: RootState) => state.editedDrawnPolygonInfo.value;
export const deletedDrawnPolygonIdState = (state: RootState) => state.deletedDrawnPolygonId.value;
//single polygon
export const singlePolygonCoordsState = (state: RootState) => state.singlePolygonCoords.value;
export const singlePolygonCenterCoordsState = (state: RootState) => state.singlePolygonCenterCoords.value;
export const isShowBreakpointsState = (state: RootState) => state.isShowBreakpoints.value;
export const isBreakpointsButtonActiveState = (state: RootState) => state.isBreakpointsButtonsActive.value;
export const isShowPolygonBreakpointsState = (state: RootState) => state.isShowPolygonBreakpoints.value;
export const isPolygonDragActiveState = (state: RootState) => state.isPolygonDragActive.value;
//multi polygons
export const multiPolygonsInfoState = (state: RootState) => state.multiPolygonsInfo.value;
// export const gardensPolygonsObjectState = (state: RootState) => state.gardensPolygonsObject.value;
export const multiPolygonEditedIDState = (state: RootState) => state.multiPolygonEditedID.value;
export const multiPolygonEditedCoordsState = (state: RootState) => state.multiPolygonEditedCoords.value;
export const polygonClusterMinDisplayZoomState = (state: RootState) => state.polygonClusterMinDisplayZoom.value;
export const isUsePolygonClusterState = (state: RootState) => state.isUsePolygonCluster.value;
//polyline
export const isDrawPolylineActiveState = (state: RootState) => state.isDrawPolylineActive.value;
export const distanceToPolygonInfoState = (state: RootState) => state.distanceToPolygonInfo.value;
export const polylineDistanceTooltipCoordsState = (state: RootState) => state.polylineDistanceTooltipCoords.value;
export const updatePolylineDistanceTooltipCoords = (state: RootState) => state.updatePolylineDistanceTooltipCoords.value;
//markers
export const markerCoordinatesState = (state: RootState) => state.markerCoordinates.value;
export const markersInfoState = (state: RootState) => state.markersInfo.value;
export const RegionMarkersInfoState = (state: RootState) => state.regionMarkersInfo.value;
//generated points
export const distanceBetweenGeneratedPointsState = (state: RootState) => state.distanceBetweenGeneratedPoints.value;
export const gridRegionCoordinatesState = (state: RootState) => state.gridRegionCoordinates.value;
export const squareGridCoordinatesState = (state: RootState) => state.squareGridCoordinates.value;
export const countryGridCoordinatesState = (state: RootState) => state.countryGridCoordinates.value;
//earth engine service
export const isEarthEngineServiceActiveState = (state: RootState) => state.isEarthEngineServiceActive.value;
export const earthEngineAreaOfInterestPolygonCoordsState = (state: RootState) =>
    state.earthEngineAreaOfInterestPolygonCoords.value;
